@if (enumContent) {
    <div
        [ngStyle]="ngStyle"
        style="display: inline-block"
    >
        {{ enumContent.label }}
    </div>
}
